
import MainPage from "../templatePage/templatePage";
import ManageLessons from "./ManageLessons";

const LessonsPage = () => {
    return <MainPage component={<ManageLessons />} />;
};

export default LessonsPage;